module.exports = __webpack_public_path__ + "img/MagnifyingGlass_Red.5ada735a.svg";